var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.visible),expression:"visible"}],staticClass:"lyf-ui-global-loading"},[_c('div',{staticClass:"lyf-ui-global-loading-content",class:{
      vertical: _vm.vertical
    }},[_vm._t("default",function(){return [_c('div',{ref:"loadingContainer",staticClass:"lyf-ui-loading-icon",style:({
          width: _vm.size + 'px',
          height: _vm.size + 'px'
        })})]}),_c('div',{staticClass:"lyf-ui-global-loading-message"},[_vm._v(_vm._s(_vm.message))])],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }